<!-- to be implemented -->
<span class="icon">{{ icon }}</span>
--
<span class="text">{{ text | i18next }}</span>
